// extracted by mini-css-extract-plugin
module.exports = {"hide":"SearchPage_hide__lGmIK","cmsPageWrapper":"SearchPage_cmsPageWrapper__swN0l","breadcrumbWrapper":"SearchPage_breadcrumbWrapper__uf3tP"};